/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ChallengeType } from './ChallengeType';
import {
    ChallengeTypeFromJSON,
    ChallengeTypeFromJSONTyped,
    ChallengeTypeToJSON,
    ChallengeTypeToJSONTyped,
} from './ChallengeType';

/**
 * 
 * @export
 * @interface WebAuthnGetAttestation
 */
export interface WebAuthnGetAttestation {
    /**
     * 
     * @type {string}
     * @memberof WebAuthnGetAttestation
     */
    challenge_id: string;
    /**
     * 
     * @type {ChallengeType}
     * @memberof WebAuthnGetAttestation
     */
    challenge_type: ChallengeType;
    /**
     * 
     * @type {object}
     * @memberof WebAuthnGetAttestation
     */
    data?: object;
}



/**
 * Check if a given object implements the WebAuthnGetAttestation interface.
 */
export function instanceOfWebAuthnGetAttestation(value: object): value is WebAuthnGetAttestation {
    if (!('challenge_id' in value) || value['challenge_id'] === undefined) return false;
    if (!('challenge_type' in value) || value['challenge_type'] === undefined) return false;
    return true;
}

export function WebAuthnGetAttestationFromJSON(json: any): WebAuthnGetAttestation {
    return WebAuthnGetAttestationFromJSONTyped(json, false);
}

export function WebAuthnGetAttestationFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebAuthnGetAttestation {
    if (json == null) {
        return json;
    }
    return {
        
        'challenge_id': json['challenge_id'],
        'challenge_type': ChallengeTypeFromJSON(json['challenge_type']),
        'data': json['data'] == null ? undefined : json['data'],
    };
}

export function WebAuthnGetAttestationToJSON(json: any): WebAuthnGetAttestation {
    return WebAuthnGetAttestationToJSONTyped(json, false);
}

export function WebAuthnGetAttestationToJSONTyped(value?: WebAuthnGetAttestation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'challenge_id': value['challenge_id'],
        'challenge_type': ChallengeTypeToJSON(value['challenge_type']),
        'data': value['data'],
    };
}

